import React, { Component } from 'react'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  span {
    font-size: 16px;
    font-weight: bold;
  }

  & > div {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    img {
      margin: 4px;
      width: 32px;
    }
  }
`

const RATING_LABEL = {
  0: '',
  1: 'Muy Malo',
  2: 'Malo',
  3: 'Regular',
  4: 'Bueno',
  5: 'Muy Bueno',
}
class Rating extends Component {
  constructor(props) {
    super(props)
    this.state = {
      rating: 0,
    }
  }

  setRating = (e) => {
    const { onRatingChange } = this.props
    const value = Number(e.currentTarget.id)
    this.setState({ rating: value }, () => onRatingChange && onRatingChange(value))
  }

  getValue = () => this.state.rating

  renderStars = () => {
    const stars = []
    for (let i = 1; i <= 5; i += 1) {
      if (i <= this.state.rating) {
        stars.push(
          <div id={i} onClick={this.setRating} key={i}> {/* eslint-disable-line*/}
            <img
              src="/assets/star_fill.svg"
              alt="fill star"
              id={i}
            />
          </div>)
      } else {
        stars.push(
          <div id={i} onClick={this.setRating} key={i}> {/* eslint-disable-line*/}
            <img
              src="/assets/star_empty.svg"
              alt="empty star"
            />
          </div>)
      }
    }
    return stars
  }

  render() {
    return (
      <Container>
        <span>{RATING_LABEL[this.state.rating]}</span>
        <div>
          {this.renderStars()}
        </div>
      </Container>
    )
  }
}

export default Rating



// WEBPACK FOOTER //
// ./src/Components/ParentPlatform/RatingModal/Rating.jsx